var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 25.1258L22.2772 29.7261C22.5685 29.9165 22.9058 30.0114 23.2472 29.9989C23.5886 29.9865 23.919 29.8673 24.1974 29.6562C24.4758 29.4451 24.6899 29.1514 24.813 28.8116C24.9361 28.4718 24.9629 28.1009 24.8899 27.745L22.9609 19.0913L29.396 13.2578C29.6561 13.0226 29.8444 12.7098 29.9365 12.3596C30.0286 12.0094 30.0204 11.6378 29.9129 11.2926C29.8054 10.9474 29.6035 10.6444 29.3333 10.4226C29.063 10.2007 28.7367 10.0701 28.3963 10.0476L19.9271 9.2955L16.613 1.11384C16.4735 0.782071 16.247 0.5004 15.9608 0.302774C15.6746 0.105149 15.3409 0 15 0C14.659 0 14.3254 0.105149 14.0392 0.302774C13.753 0.5004 13.5265 0.782071 13.387 1.11384L10.0729 9.2765L1.6037 10.0286C1.26329 10.0511 0.936979 10.1817 0.666722 10.4036C0.396466 10.6254 0.194616 10.9284 0.0871248 11.2736C-0.0203661 11.6188 -0.0285838 11.9904 0.0635275 12.3406C0.155639 12.6908 0.343869 13.0036 0.604016 13.2388L7.03912 19.0723L5.11009 27.73C5.03689 28.0859 5.06346 28.457 5.18648 28.797C5.3095 29.137 5.52355 29.4309 5.802 29.6421C6.08044 29.8533 6.41099 29.9726 6.75251 29.9851C7.09403 29.9975 7.43144 29.9026 7.72276 29.7121L15 25.1258Z",
    fill: "#D6DAE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarLoader);
export default __webpack_public_path__ + "static/media/starLoader.68c2fc0edcd4636b7b62e78d10e17c22.svg";
export { ForwardRef as ReactComponent };